module.exports = __webpack_public_path__ + "img/worm-prepared.5bbec443.png";